import { render, staticRenderFns } from "./ModelDashboard.vue?vue&type=template&id=7f5fec40"
import script from "./ModelDashboard.vue?vue&type=script&lang=js"
export * from "./ModelDashboard.vue?vue&type=script&lang=js"
import style0 from "./ModelDashboard.vue?vue&type=style&index=0&id=7f5fec40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports